export default __webpack_public_path__ + "static/media/buddha-baby.e2dc6fa5.png";